import { Box, Typography } from '@mui/material';
import React from 'react';
import { STATUS_SALE } from '../../../../helpers/enums';
import { ccyFormat } from '../../../../helpers/helper';

const STATUS_ACCENT = {
  [STATUS_SALE.FINISHED]: '#006100',
  [STATUS_SALE.RESERVED]: '#9A6700',
  [STATUS_SALE.CANCELED]: '#9C0006',
};

const CashierSaleCollapseHeader = ({
  nameSale,
  totalSale,
  totalQuantity,
  orderCount,
  dateLabel,
  amountBadges,
  statusChip,
  transferChip,
  transferStatusChip,
  heldChip,
  saleStatus,
}) => {
  const accentColor = STATUS_ACCENT[saleStatus] || '#475569';

  return (
    <Box display='flex' alignItems='center' width='100%' gap={1}>
      {/* status accent dot */}
      <Box
        sx={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          bgcolor: accentColor,
          flexShrink: 0,
        }}
      />

      {/* main info */}
      <Box flex={1} minWidth={0}>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: '0.8rem',
            lineHeight: 1.2,
            color: '#1a1a1a',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {nameSale}
        </Typography>
        <Box display='flex' alignItems='center' gap={0.75} mt={0.25} flexWrap='wrap'>
          <Typography sx={{ fontSize: '0.65rem', color: '#888', fontWeight: 500 }}>
            {totalQuantity} uds
          </Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#ccc' }}>·</Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#888', fontWeight: 500 }}>
            {orderCount} {orderCount === 1 ? 'item' : 'items'}
          </Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#ccc' }}>·</Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#aaa', fontWeight: 400 }} noWrap>
            {dateLabel}
          </Typography>
          {amountBadges}
          {statusChip}
          {heldChip}
          {transferChip}
          {transferStatusChip}
        </Box>
      </Box>

      {/* total */}
      <Typography
        sx={{
          fontWeight: 900,
          fontSize: '0.88rem',
          color: '#1a1a1a',
          flexShrink: 0,
          letterSpacing: '-0.01em',
        }}
      >
        ${ccyFormat(totalSale)}
      </Typography>
    </Box>
  );
};

export default CashierSaleCollapseHeader;